// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__mYjgY","loader":"ContentLoader_loader__1WTAN","disabled":"ContentLoader_disabled__OTviE"};